define([
    'jquery',
    'lodash/object/assign',
    'lodash/function/bindAll',
    './components/Zoomer',
    'hammerjs',
    'jquery-hammerjs'
], function ($, assign, bindAll, Zoomer, Hammer) {
    'use strict';

    var ExhibitionDetailPage = function (options) {
        assign(this.options, options);
        this.initialize();
    };

    assign(ExhibitionDetailPage.prototype, {
        options: {},

        initialize: function () {
            bindAll(this);

            this.$el = $('body');
            this.$detailPanel = this.$el.find('.js-detail-panel');

            this.bindEvents();
            this.initializeZoomingViewer();
            this.resizeHandler();
        },

        bindEvents: function () {
            this.$el.on('click', '.js-btn-toggle', this.clickBtnDetailToggle);
            this.$el.on('click', '.btn-extended-captions', this.clickBtnToggleExtendedCaptions);

            this.$detailPanel.hammer().on('swipe', this.detailPanelSwipe);

            this.options.appModel.on('change', this.modelChangedHandler);
            $(window).resize(this.resizeHandler);
        },

        clickBtnToggleExtendedCaptions: function (event) {
            this.toggleExtendedCaptions();
        },

        detailPanelSwipe: function (event) {
            if (this.options.appModel.get('deviceType') === 'desktop') {
                if(event.gesture.direction & Hammer.DIRECTION_HORIZONTAL) {
                    let opening = event.gesture.direction === Hammer.DIRECTION_LEFT;
                    this.toggleDetailPanel(opening);
                }
            }
        },

        resizeHandler: function () {
            var $navBar = this.$el.find('#nav-bar'),
                $content = this.$el.find('#content');

            $content.height($(window).height() - $navBar.height());
        },

        modelChangedHandler: function () {
            if (this.options.appModel.isChanged('deviceType')) {
                this.deviceTypeChangedHandler();
            }
        },

        deviceTypeChangedHandler: function () {
            var deviceType = this.options.appModel.get('deviceType');
            this.$el.find('.mobile.js-btn-toggle').removeClass('active');
            this.$el.find('.js-btn-toggle:not(.mobile)').removeClass('inverted-arrow-icon');
            this.$detailPanel.removeAttr('style').data('shown', deviceType === 'desktop');
        },

        clickBtnDetailToggle: function (event) {
            this.toggleDetailPanel();
            event.preventDefault();
        },

        toggleDetailPanel: function (show, animate) {
            var animateTo = {};

            show = show !== undefined ? show : !this.$detailPanel.data('shown');
            animate = animate !== undefined ? animate : true;

            if (show !== this.$detailPanel.data('shown')) {
                if (this.options.appModel.get('deviceType') === 'mobile') {
                    animateTo.bottom = show === true ? '0%' : '-100%';
                    $('.mobile.toggle-btn').toggleClass('active', show);
                } else {
                    animateTo.right = show === true ? 0 : -344;
                    $('.js-btn-toggle:not(.mobile)').toggleClass('inverted-arrow-icon', !show);
                }

                if (animate) {
                    this.$detailPanel.stop().animate(animateTo, 250);
                } else {
                    this.$detailPanel.css(animateTo);
                }

                this.$detailPanel.data('shown', show);
            }
        },

        initializeZoomingViewer: function () {
            var $zoomer = $('#zoomer'),
                zoomer;

            zoomer = new Zoomer.Zoomer({
                $el: $zoomer,
                configureViewerFromDataAttribute: true,
                // Specify additional OpenSeadragon.Viewer options here
                viewerOptions: {

                }
            });
            zoomer.openTileSourceFromDataAttribute();
        },

        toggleExtendedCaptions: function () {
            var $extendedCaption = this.$el.find('.js-long-caption'),
                $shortCaption = this.$el.find('.js-short-caption'),
                show = !$extendedCaption.is(':visible'),
                btnText = 'Shortcaptions';

            if ($extendedCaption.is(':animated') === false && $shortCaption.is(':animated') === false) {
                if (show === false) {
                    btnText = 'Extended captions';
                    $extendedCaption.stop().slideToggle(300, function () {
                        $shortCaption.stop().slideToggle(300);
                    });
                } else {
                    $shortCaption.stop().slideToggle(300, function () {
                        $extendedCaption.stop().slideToggle(300);
                    });
                }
            }

            this.$el.find('.btn-extended-captions').text(btnText)
                .removeClass(show ? 'read-less' : 'read-more')
                .addClass(show ? 'read-more' : 'read-less');
        }
    });

    return ExhibitionDetailPage;
});



/** WEBPACK FOOTER **
 ** ./js/view/ExhibitionDetailPage.js
 **/